import { useState } from "react";
import styles from "../styles.module.css";

type Props = {
  title: string;
  value?: (File | undefined)[] | null;
  setter: React.Dispatch<React.SetStateAction<(File | undefined)[] | null>>;
  required?: boolean;
  lista?: boolean;
};

const CampoAnexo = ({ title, value, setter, required, lista }: Props) => {
  const nome = title.toLowerCase().replace(" ", "_");

  return (
    <div className={styles.campo}>
      <label htmlFor={nome}>
        {title}
        <span className={styles.required}>{required && "*"}</span>:
      </label>
      <div className={styles.listaCampos}>
        {value &&
          value.map((anexo, index) => (
            <input
              type={"file"}
              key={index}
              required={required}
              multiple={false}
              accept="application/pdf"
              onChange={(e) => {
                const files = e.currentTarget.files;
                if (files) {
                  let temp = [...value];
                  temp[index] = files[0];
                  setter(temp);
                }
              }}
            />
          ))}
        {lista && (
          <div className="flex">
            <button
              className={styles.addBtn}
              onClick={(e) => {
                e.preventDefault();
                if (value) {
                  let temp: any[] = [...value];
                  temp.push(undefined);
                  setter(temp);
                } else {
                  setter([]);
                }
              }}
            >
              Adicionar Documento
            </button>
            {value && value?.length > 1 && (
              <button
                className={styles.removeBtn}
                onClick={(e) => {
                  e.preventDefault();
                  let temp = [...value];
                  temp.pop();
                  setter(temp);
                }}
              >
                Remover Documento
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default CampoAnexo;
